import { Link } from "@mui/material";
import React from "react";
import { colorVariables, customValue } from "../../../utils/colorVariable";

interface ICustomLink {
  icon?: React.ReactNode;
  label: string;
  isActive?: boolean;
  link: string;
}

export const CustomLink: React.FC<ICustomLink> = ({
  label,
  icon,
  isActive,
  link,
}) => {
  return (
    <Link
      href={link}
      underline="none"
      color={colorVariables.black}
      bgcolor={isActive ? colorVariables.gray : colorVariables.white}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={0.5}
      padding={1}
      borderRadius={customValue.borderRadius}
    >
      {icon ? icon : ""}
      {label}
    </Link>
  );
};
